import { List, Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const TutorialGroupDisplayRecord = Record({
  id: null,
  label: null,
  description: null,
  tips: List(),
  isComplete: false,
  gateMessage: null,
  gateApplicableMessage: null,
  completedMessage: null
});

const data = {
  collections: {
    tips: "TutorialTipDisplayRecord"
  }
};

createFromJS.registerCallback(
  "TutorialGroupDisplayRecord",
  createFromJS.createNestedCallback(TutorialGroupDisplayRecord, data)
);
